import { render, staticRenderFns } from "./CourseStructureCopySlidebar.vue?vue&type=template&id=503560ed"
import script from "./CourseStructureCopySlidebar.vue?vue&type=script&lang=js"
export * from "./CourseStructureCopySlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports